<script>
import TypeAheadControl from "./TypeAheadControl";

export default {
  name: "AjaxTypeAheadControl",

  extends: TypeAheadControl,
  data() {
    return {
      typeaheadComponent: "BaseAjaxTypeAhead"
    };
  }
};
</script>
